import StatusBadge from "../../midpoint/intelligence/StatusBadge";
import { formatConfidence } from "../../../weather/colombiaWeatherRiskApi";

const CONFIDENCE_COPY = {
  high: "High confidence",
  medium: "Medium confidence",
  low: "Low confidence",
  unknown: "Unknown confidence",
};

const TONES = {
  high: "confirmed",
  medium: "medium",
  low: "disputed",
  unknown: "neutral",
};

const WeatherConfidenceBadge = ({ confidence }) => {
  const normalized = confidence || "unknown";
  const label = CONFIDENCE_COPY[normalized] || formatConfidence(normalized);

  return <StatusBadge label={label} tone={TONES[normalized] || "neutral"} />;
};

export default WeatherConfidenceBadge;
